const LENGTH = 8;
const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

// Fills the ID number in <ReferenceIdField> when the user hits Generate.
export const generateReferenceId = () =>
  Array.from({ length: LENGTH }, () => ALPHABET[Math.floor(Math.random() * ALPHABET.length)]).join(
    '',
  );

// <ReferenceIdField>'s two boxes → the one string the server stores; this hyphen is real.
export const joinReferenceId = ({ idPrefix, idNumber }) =>
  [idPrefix, idNumber].filter(Boolean).join('-');

// The reverse: a saved id goes back whole into the number box, never split on its hyphen.
export const splitReferenceId = (referenceId) => ({ idPrefix: '', idNumber: referenceId ?? '' });
